export const stickyActionBar = {
  position: 'sticky',
  bottom: 0,
  backgroundImage: 'linear-gradient(#fafafa00, #fafafa 8px)',
  // In grid layout, the items only have a left and top padding, so overflow a bit on the right to hide the right shadow
  // of the previous cards
  paddingRight: 10,
  minWidth: 'calc(100% + 10px)',
} as const;
